"use strict";

exports.__esModule = true;
exports.showCot = exports.clickCotOtherOfferType = exports.clickCotNeedHelp = exports.clickCotItem = exports.clickCotFaqMoreInfo = exports.clickCotFaqItem = exports.clickCotCustomerSupport = exports.clickCotAlreadySubscriber = exports.chooseCotItem = void 0;

var _constants = require("../constants");

const eventLabel = {
  eventlabel: 'subscriptionshop/cta-offer-product'
};

const showCot = user => ({ ..._constants.eventBase,
  ...eventLabel,
  ..._constants.conversionWall,
  ..._constants.show,
  ...(0, _constants.identityAccountId)(user)
});

exports.showCot = showCot;

const chooseCotItem = (user, offerTitle) => ({ ..._constants.eventBase,
  ...eventLabel,
  ..._constants.conversionWall,
  eventaction: `click-choose-${offerTitle.toLowerCase()}`,
  ...(0, _constants.identityAccountId)(user)
});

exports.chooseCotItem = chooseCotItem;

const clickCotItem = (user, offerTitle) => ({ ..._constants.eventBase,
  ...eventLabel,
  ..._constants.conversionWall,
  eventaction: `click-${offerTitle.toLowerCase()}`,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCotItem = clickCotItem;

const clickCotNeedHelp = user => ({ ..._constants.eventBase,
  ...eventLabel,
  ..._constants.conversionWall,
  eventaction: `click-help-request`,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCotNeedHelp = clickCotNeedHelp;

const clickCotAlreadySubscriber = user => ({ ..._constants.eventBase,
  ...eventLabel,
  ..._constants.conversionWall,
  eventaction: `click-already-subscriber`,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCotAlreadySubscriber = clickCotAlreadySubscriber;

const clickCotOtherOfferType = user => ({ ..._constants.eventBase,
  ...eventLabel,
  ..._constants.conversionWall,
  eventaction: `click-other-product`,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCotOtherOfferType = clickCotOtherOfferType;

const clickCotFaqMoreInfo = user => ({ ..._constants.eventBase,
  ...eventLabel,
  ..._constants.conversionWall,
  eventaction: `click-faq-more`,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCotFaqMoreInfo = clickCotFaqMoreInfo;

const clickCotFaqItem = (user, faqTitle) => ({ ..._constants.eventBase,
  ...eventLabel,
  ..._constants.conversionWall,
  eventaction: `click-${faqTitle.toLowerCase()}`,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCotFaqItem = clickCotFaqItem;

const clickCotCustomerSupport = user => ({ ..._constants.eventBase,
  ...eventLabel,
  ..._constants.conversionWall,
  ..._constants.customerSupport,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCotCustomerSupport = clickCotCustomerSupport;